import type { SvgIconTypes } from '@uikit/svg-icon';
import { Target, Size, type DataAttrs, TagNameClickable } from '@uikit/types';

export interface Props {
    text?: string;
    custom?: boolean;
    disabled?: boolean;
    dropdown?: boolean;
    rounded?: boolean;
    fullWidth?: boolean;
    type?: Type;
    element?: HTMLButtonElement | HTMLAnchorElement | HTMLDivElement;
    href?: string;
    target?: Target;
    color?: Color;
    tagName?: TagNameClickable;
    size?: Size;
    icon?: SvgIconTypes.IconData;
    iconRight?: SvgIconTypes.IconData;
    classes?: string;
    attrs?: Partial<Attrs>;
    iconRotationAngle?: SvgIconTypes.RotationAngle;
    iconRightRotationAngle?: SvgIconTypes.RotationAngle;
    iconProps?: Omit<SvgIconTypes.Props, 'icon'>;
    iconRightProps?: Omit<SvgIconTypes.Props, 'icon'>;
    hasPadding?: boolean;
}

interface Attrs extends DataAttrs {
    rel: string;
    tabindex: number;
}

export enum Color {
    Brand = 'brand',
    Secondary = 'secondary',
    Ghost = 'ghost',
    White = 'white',
    Green = 'green',
    Indigo = 'indigo',
    Yellow = 'yellow',
}

export enum Type {
    Button = 'button',
    Reset = 'reset',
    Submit = 'submit',
}

export { TagNameClickable as TagName };
